import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AdminSettingsService {
  baseUrl: any;

  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseUrl;
  }

  adminSettingsCreate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-hourly-rate-markers', payload);
  }

  adminSettingsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-hourly-rate-markers', payload);
  }

  quoteSettingsCreate(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quoteid-settings', payload);
  }

  quoteIdSettingsList(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-quoteid-settings', payload);
  }

  setTLSSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-tls-settings', payload);
  }

  getTLSSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-tls-settings');
  }
  getClientTLSSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/client-tls-settings', payload);
  }
  addMachineError(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/add-error', payload);
  }

  getMachineError(payload: any): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/error-list', payload);
  }

  deleteMachineError(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/delete-error', payload);
  }

  blockErrorMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/block-error', payload);
  }

  unblockErrorMachine(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/unblock-error', payload);
  }

  updateErrorStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/update-error-status', payload);
  }

  addJobColour(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-job-color-settings', payload);
  }

  getJobColor(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-job-color-settings');
  }

  bulkDeleteBlockUnblock(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/bulk-update-error', payload);
  }

  testEmailSettings(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/test101', payload);
  }

  //Proposal email
  saveProposalEmail(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/save-proposal-settings', payload);
  }

  getProposalSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-proposal-settings');
  }

  changeJobStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-job-status-settings', payload);
  }

  adminRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-admin-settings', payload);
  }

  engineerRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-engineer-settings', payload);
  }

  clientRegistration(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-client-settings', payload);
  }

  getAdminSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-admin-settings');
  }

  getClientSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-client-settings');
  }

  getEngineerSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-engineer-settings');
  }

  getJobStatusSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-job-status-settings');
  }

  changeQuoteStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quote-status-settings', payload);
  }

  getQuoteStatusSettings(): Observable<any> {
    return this.http.get(this.baseUrl + 'settings/get-quote-status-settings');
  }

  setQuoteId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/set-quoteid-settings', payload);
  }

  getQuoteId(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/get-quoteid-settings', payload);
  }

  //Industry
  industryList(
    filters: Object = { deletedAt: null, active: 1 },
    orderBy: Record<string, 1 | -1> = { name: 1 }
  ): Observable<any> {
    let params = { filters, orderBy };
    return this.http.post(this.baseUrl + 'leads/industry/industry-list', params);
  }

  createIndustry(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leads/industry/create', payload);
  }

  updateIndustry(id: string, payload: any): Observable<any> {
    return this.http.post(this.baseUrl + `leads/industry/${id}/update`, payload);
  }

  deleteIndustry(id: string, payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + `leads/industry/${id}/delete`, payload);
  }

  // Manage Tag
  tagList(): Observable<any> {
    return this.http.get(this.baseUrl + 'deal/get-tag-proposal');
  }

  createTag(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'deal/add-tag-proposal', payload);
  }

  updateTag(payload: any): Observable<any> {
    return this.http.put(this.baseUrl + `deal/update-tag-proposal`, payload);
  }

  deleteTag(payload: any): Observable<any> {
    return this.http.patch(this.baseUrl + `deal/soft-delete-tag-proposal`, payload);
  }

  // Manage Lead Source
  sourceList(): Observable<any> {
    return this.http.get(this.baseUrl + 'leadSource/get-all-lead-source');
  }

  createSource(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'leadSource/add-lead-source', payload);
  }

  // updateSource(id: number | string, payload: any): Observable<any> {
  //   return this.http.put(`${this.baseUrl}leadSource/update-lead-source/${id}`, payload);
  // }

  updateSource(payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}leadSource/update-lead-source/${payload._id}`, payload);
  }

  // deleteSource(payload: any): Observable<any> {
  //   return this.http.delete(`${this.baseUrl}leadSource/delete-lead-source/${payload._id}`, payload);
  // }

  deleteSource(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}leadSource/delete-lead-source/${id}`);
  }

  resetApi(id: any): Observable<any> {
    return this.http.post(this.baseUrl + `leadSource/${id}/reset-api-key`, {});
  }

  // GET lead-statuses

  // POST lead-statuses
  createOrUpdateLeadStatus(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'settings/lead-statuses', payload);
  }
  // DELETE lead-statuses/:id
  deleteLeadStatus(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}settings/lead-statuses/${id}`);
  }

  // Team Management APIs
  createTeam(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'team/create-team', payload);
  }

  getTeamList(
    page: number = 1,
    limit: number = 10,
    filters: {
      search?: string;
      name?: string;
      countries?: string[];
      eeids?: string[];
      areaManagers?: string[];
      members?: string[];
    } = {}
  ): Observable<any> {
    return this.http.post(`${this.baseUrl}team/list-teams`, { page, limit, ...filters });
  }

  getAllTeamsForAssignment(): Observable<any> {
    return this.http.get(`${this.baseUrl}team/all-teams-assignment`);
  }

  updateTeam(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}team/update-team/${id}`, payload);
  }

  deleteTeam(id: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}team/delete-team/${id}`, {});
  }

  getDeputyRoles(): Observable<any> {
    return this.http.get(this.baseUrl + 'master/deputy-roles');
  }

  //START HERE  FOR LMS

  getAllUsers(): Observable<any> {
    return this.http.get(this.baseUrl + 'user/all-users');
  }

  getUsersForTeamAssignment(
    filters: {
      deputyRoles?: string[];
      applyDeputyFilter?: boolean;
      countries?: string[];
      clients?: string[];
      areaManagers?: string[];
      sites?: string[];
      eeids?: string[];
    } = {}
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'user/team-assignment-users', filters);
  }

  getIndependentUsersForTeam(
    page: number = 1,
    limit: number = 50,
    search: string = ''
  ): Observable<any> {
    return this.http.post(this.baseUrl + 'user/team-assignment-users', {
      page,
      limit,
      search,
    });
  }

  migrateData(payload: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'data-sync/migrate', payload);
  }

  getMigrationLogs(): Observable<any> {
    return this.http.get(this.baseUrl + 'data-sync/migration-logs');
  }

  // Path Management APIs
  createPath(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'path/pathcreate', payload);
  }

  getallCoursesForPaths(): Observable<any> {
    return this.http.get(this.baseUrl + 'course/getallCoursesForPaths');
  }

  getPathList(search = ''): Observable<any> {
    return this.http.get(this.baseUrl + 'path/allpaths', { params: search ? { search } : {} });
  }

  getPathListPaginated(page: number = 1, limit: number = 10, search = '', sortField = 'createdAt', sortOrder = -1, filters: any = {}): Observable<any> {
    return this.http.post(this.baseUrl + 'path/allpaths-paginated', { 
      page, 
      limit, 
      search, 
      sortField, 
      sortOrder,
      teamIds: filters.teamIds || [],
      learnerIds: filters.learnerIds || [],
      courseIds: filters.courseIds || []
    });
  }

  getPathById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}path/pathdetails/${id}`);
  }

  updatePath(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}path/updatelavel/${id}`, payload);
  }

  deletePath(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}path/delete/${id}`);
  }

  // Level Management APIs
  createLevel(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'level/create', payload);
  }

  getLevelList(search = ''): Observable<any> {
    return this.http.get(this.baseUrl + 'level/all', { params: search ? { search } : {} });
  }

  updateLevel(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}level/update/${id}`, payload);
  }

  deleteLevel(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}level/delete/${id}`);
  }

  // Badge Management APIs
  createBadge(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'badge/badgecreate', payload);
  }

  getBadgeList(search = ''): Observable<any> {
    return this.http.get(this.baseUrl + 'badge/allbadges', { params: search ? { search } : {} });
  }

  getBadgeById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}badge/badgedetails/${id}`);
  }

  updateBadge(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}badge/updatebadge/${id}`, payload);
  }

  deleteBadge(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}badge/delete/${id}`);
  }

  // Course Category Management APIs
  createCourseCategory(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'course-category/categorycreate', payload);
  }

  getCourseCategoryList(search = ''): Observable<any> {
    return this.http.get(this.baseUrl + 'course-category/allcategories', {
      params: search ? { search } : {},
    });
  }

  getCourseCategoryById(id: string): Observable<any> {
    return this.http.get(`${this.baseUrl}course-category/categorydetails/${id}`);
  }

  updateCourseCategory(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}course-category/updatecategory/${id}`, payload);
  }

  deleteCourseCategory(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}course-category/delete/${id}`);
  }

  // Product Management APIs
  createProduct(payload: any): Observable<any> {
    return this.http.post(this.baseUrl + 'product/create', payload);
  }

  getProductList(search = ''): Observable<any> {
    return this.http.get(this.baseUrl + 'product/all', { params: search ? { search } : {} });
  }

  updateProduct(id: string, payload: any): Observable<any> {
    return this.http.put(`${this.baseUrl}product/update/${id}`, payload);
  }

  deleteProduct(id: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}product/delete/${id}`);
  }

  getCertificateList(): Observable<any> {
    return this.http.get(this.baseUrl + 'certificate/get-all-templates');
  }

  setDefaultCertificate(id: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}certificate/set-default/${id}`, {});
  }
}
